window.tabSlider = tabSlider;

function tabSlider(options) {

	let container = document.getElementById(options.elementId);

	container.adjustHeights = () => {
		let outerHeight = 0;
		for (const desc of container.getElementsByClassName('css-js-tab-element')) {
			let height = 0;
			for (const content of desc.children) {
				let style = getComputedStyle(content);
				height += content.scrollHeight + parseInt(style.marginTop) + parseInt(style.marginBottom);
			}

			let style = getComputedStyle(desc);
			height += parseInt(style.paddingTop) + parseInt(style.paddingBottom);
			if (height > outerHeight) {
				outerHeight = height;
			}
		}
		return outerHeight;
	}
	for (const button of container.querySelectorAll('.css-js-tab-button')) {
		button.addEventListener("click", (e) => {
			e.preventDefault();
			container.moveSlide(button);

		});
	}

	container.moveSlide = (newElement) => {
		let newClass = newElement.dataset.target;
		for (const everyTab of container.querySelectorAll('.css-js-tab-button')) {
			everyTab.removeAttribute('data-selected')
		}
		newElement.setAttribute('data-selected', '');

		for (const everyContent of container.querySelectorAll('.css-js-tab-element')) {
			everyContent.removeAttribute('data-current')
		}
		for (const everyContent of container.querySelectorAll('[data-selector="' + newClass + '"]')) {
			everyContent.setAttribute('data-current', '');

		}
		newElement.parentNode.scroll({
			left: newElement.offsetLeft - (newElement.parentNode.offsetWidth /2) + newElement.parentNode.offsetLeft,
			top: 0,
			behavior: 'smooth'
		})
	}
	let tallest = container.adjustHeights();
	for (const everyContent of container.querySelectorAll('.css-js-tab-element')) {
		everyContent.style.height = tallest + 'px';
	}
	window.addEventListener("resize", (e) => {
		let tallest = container.adjustHeights();
		for (const everyContent of container.querySelectorAll('.css-js-tab-element')) {
			everyContent.style.height = tallest + 'px';
		}
	});


}
